// Vue
import { defineStore } from 'pinia';

// Common
import i18n from '@/common/i18n';

// Repository
import SigninResetRepository from '@/repositories/signinResetRepository';

// commonProject
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

export const useSigninResetStore = defineStore({
    id: 'signinReset',
    state: () => ({
        pwdrstPk: '', // パスワードリセット履歴PK
    }),
    getters: {
        getPwdrstPk() {
            return this.pwdrstPk;
        },
    },
    actions: {
        /**
         * 全てリセット
         */
        async reset() {
            this.pwdrstPk = '';
        },
        /**
         * パスワードリセット1APIをコールして、パスワードリセットIDを取得する。
         * @param {Object} requestBody
         * @returns response
         */
        async sendPasswordResetAction(API_URL, requestBody) {
            const signinResetRepository = new SigninResetRepository();
            try {
                // パスワードリセット1APIをコールする。
                const response = await signinResetRepository.sendPasswordReset1Api(API_URL, requestBody, null);

                /*
                // 例外エラーハンドリング共通処理
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                */

                // 本機能では例外エラーを設定しないこと。
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * パスワードリセット2APIをコールして、パスワードリセットの認証結果を取得する。
         * @param {Object} requestBody
         * @returns response
         */
        async sendPasswordResetCodeAndNewPasswordAction(API_URL, requestBody) {
            const signinResetRepository = new SigninResetRepository();
            try {
                // パスワードリセット2APIをコールする。
                const response = await signinResetRepository.sendPasswordReset2Api(API_URL, requestBody, null);

                // 例外エラーハンドリング共通処理
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存する。
        storage: sessionStorage,
    },
});
